import { useContext } from "react";
import { AppMessagesContext } from "../contexts";

export function useAppMessages() {
  return useContext(AppMessagesContext);
}
